export interface PersonnelItem {
  id: string;
  first_name?: string;
  last_name?: string;
}

export interface ContactItem {
  id: string;
  first_name?: string;
  last_name?: string;
  preferred_name?: string;
  email_address?: string;
  phone_number?: string;
}

export interface LocationData {
  id: string;
  name: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
}

export interface IncidentForm {
  name: string;
  description?: string;
  status: string;
  incident_type_id: string | null;
  submitted_by_id: string | null;
  client_id: string | null;
  project_id: string | null;
  shift_id: string | null;
  occurred_date: string;
  personnel_involved: PersonnelItem[];
  contacts_involved: ContactItem[];
  location_id: string | null;
}

export interface IncidentPayload {
  incident: IncidentForm;
}
